import React from 'react';
import { connect } from 'react-redux';
import { toast } from '../../../utilities/appToast';
import { fetchAjusteNotificaciones } from '../../../actions/notificacionesActions';
import { updateAjusteNotificacionesApi } from '../../../api/axios';
import BigSpinner from '../../General/BigSpinner';


class AjustesNotificaciones extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ajustes: this.props.ajustes,
      seleccionarTodo: false,
      submitted: false
    }
  }

  componentDidMount() {
    this.props.fetchAjusteNotificaciones({ IdUser: this.props.userId });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ajustes !== this.props.ajustes) {
      if (this.props.ajustes.every(ajuste => ajuste.checked)) {
        this.setState({ seleccionarTodo: true });
      }
      this.setState({ ajustes: this.props.ajustes });
    }
  }

  handleChangeCheckbox = (id) => {

    const updatedAjustes = this.state.ajustes.map(ajuste => {
      if (ajuste.id === id) {
        return {
          ...ajuste,
          checked: !ajuste.checked
        };
      }
      return ajuste;
    });

    const isAllSelected = updatedAjustes.every(ajuste => ajuste.checked);

    this.setState({
      ajustes: updatedAjustes,
      seleccionarTodo: isAllSelected
    });
  };

  handleSelectAllCheckbox = (seleccionarTodo) => {

    const updatedAjustes = this.state.ajustes.map(ajuste => {
      return {
        ...ajuste,
        checked: seleccionarTodo
      };
    });

    this.setState({
      ajustes: updatedAjustes,
      seleccionarTodo: seleccionarTodo
    });
  };

  onSubmit = (event) => {

    event.preventDefault();

    if (this.state.submitted) {
      return;
    } else {
      this.setState({ submitted: true });
    }

    let opcionesNotificacion = this.state.ajustes.map(ajuste => {
      return {
        idTipoNotificacion: ajuste.id,
        activado: ajuste.checked
      }
    })
    
    let request = {
      IdUser: this.props.userId,
      OpcionesNotificacion: opcionesNotificacion
    }

    let post = updateAjusteNotificacionesApi(request);

    post.then(res => {
      toast.success("Ajustes actualizados con éxito.");
      this.props.fetchAjusteNotificaciones({ IdUser: this.props.userId });
      this.setState({ submitted: false, seleccionarTodo: false });
      return;
    }).catch(err => {
      toast.error("No pudimos actualizar los ajustes.");
      this.setState({ submitted: false });
    });
  }

  goBack = () => {
    window.history.go(-1);
  }


  render = () => {

    const { ajustes, seleccionarTodo, submitted } = this.state

    return (
      <div className="container">

        <h4 className="text-themecolor color-rojo-megatone">Ajustes de Notificaciones</h4>

        <div hidden={!this.props.loadingNotificaciones}>
          <BigSpinner message="Cargando ajustes de notificaciones..." />
        </div>

        <div className="card" hidden={this.props.loadingNotificaciones}>

          <div className="row align-items-center justify-content-center">
            <div className="col-12 col-sm-9 col-md-7 col-lg-6">

              <div className="list-group">
                <div 
                  className="row align-items-center justify-content-center justify-content-sm-evenly list-group-item d-flex" 
                  style={{ backgroundColor: 'transparent', borderColor: 'transparent' }}
                >
                  <div className="col-sm-6 text-center text-sm-start">
                    <h6>Notificar:</h6>
                  </div>

                  <div className="col-12 col-sm-6 text-center text-sm-start">
                    <div className="row align-items-center justify-content-center">

                      <div className="col-auto form-switch form-check text-start text-lg-end">
                        <input
                          type="checkbox" 
                          name="seleccionarTodo" 
                          className="form-check-input"
                          checked={seleccionarTodo}
                          onChange={() => this.handleSelectAllCheckbox(!seleccionarTodo)}
                        />
                      </div>

                      <div className="col-auto">
                        <h6 className="d-inline-flex">Todo</h6>
                      </div>

                      <div className="d-none d-sm-block col-sm-0 col-lg-3"></div>
                    </div>
                  </div>

                </div>
              </div>

              {
                ajustes.map((ajuste, i) => {
                  return (
                    <div 
                      key={i} 
                      className="list-group" 
                      hidden={ajuste.id === 6 && this.props.tipoUsuario === (3 || 4)}
                    >
                      <div className="row align-items-center justify-content-center justify-content-sm-evenly list-group-item d-flex m-0">

                        <div className="col-auto col-sm-6">
                          <span>{ajuste.nombre}</span>
                        </div>
                        
                        <div className="col-12 col-sm-5">
                          <div className="row align-items-center justify-content-center">

                            <div className="col-auto form-switch">
                              <input  
                                name={`check-${i}`}
                                type="checkbox" 
                                className="form-check-input d-block" 
                                checked={ajuste.checked}
                                onChange={() => this.handleChangeCheckbox(ajuste.id)}
                              />
                            </div>

                            <div className="col-auto">
                              <label htmlFor={`check-${i}`} className="custom-control-label text-capitalize">
                                <span className={`label label-item label-${ajuste.checked ? "success" : "grey"}`}>
                                  {ajuste.checked ? "Activo" : "Inactivo"}
                                </span>
                              </label>
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>
                  )
                })
              }
            </div>

            <form 
              className="row align-items-center justify-content-center form-horizontal form-material p-10" 
              onSubmit={this.onSubmit}
              disabled={submitted}
            >
              <div className="col-auto">
                <button 
                  type="submit" 
                  className="btn btn-sm background-rojo-megatone waves-light mx-2"
                >
                  Guardar
                </button>
              </div>


              <div className="col-auto">
                <button 
                  type="button"
                  onClick={this.goBack} 
                  className="btn btn-sm btn-light waves-effect waves-light mx-2 my-2"
                >
                  Cancelar
                </button>
              </div>
            </form>

          </div>
        </div>
      </div>
    );
  };
}


const mapStateToProps = state => ({
  userId: state.general.userId,
  tipoUsuario: state.general.tipoUsuario,
  ajustes: state.notificaciones.ajustes,
  loadingNotificaciones: state.notificaciones.loadingNotificaciones
});

export default connect(mapStateToProps, { fetchAjusteNotificaciones }) (AjustesNotificaciones);